// 黑瓜档案馆 —— 内容假数据（简体中文 · 中立编辑部叙事）

export const site = {
  name: "黑瓜档案馆",
  slogan: "补瓜 · 追脉络 · 翻老料",
  desc: "把散落在各处的往期旧料收进档案柜，按年份与主题归档，帮你补上前面的瓜、看清一件事是怎么发展到今天的。",
};

export interface Category {
  key: string;
  label: string;
  icon: string;
  blurb: string;
}

export const categories: Category[] = [
  { key: "all", label: "全部", icon: "ri-stack-line", blurb: "跨分类的总目录" },
  { key: "movie", label: "影视风云", icon: "ri-film-line", blurb: "剧集与电影的话题起伏" },
  { key: "show", label: "综艺现场", icon: "ri-tv-2-line", blurb: "国民节目的高光与争议" },
  { key: "music", label: "音乐现场", icon: "ri-mic-line", blurb: "金曲翻红与版权往事" },
  { key: "celebrity", label: "网红江湖", icon: "ri-flashlight-line", blurb: "流量明星与素人走红" },
  { key: "business", label: "商业起伏", icon: "ri-line-chart-line", blurb: "造星与平台的商业模式" },
  { key: "trend", label: "行业观察", icon: "ri-eye-line", blurb: "舆论与行业趋势复盘" },
];

export interface ArchiveItem {
  id: string;
  category: string;
  title: string;
  year: string;
  tag: string;
  excerpt: string;
  tone: string;
  image: string;
}

export const featuredItems: ArchiveItem[] = [
  {
    id: "f-01",
    category: "影视风云",
    title: "口碑巅峰到争议发酵：一部爆款剧的完整生命周期复盘",
    year: "2021 归档",
    tag: "高开争议",
    tone: "补课向",
    excerpt: "从开分一路走高到讨论度顶峰，再到结局前后的口碑分化。我们用一条时间线复盘这部现象级剧集如何定义了一个夏天的热搜。",
    image: "https://readdy.ai/api/search-image?query=cinematic%20production%20scene%20with%20film%20slate%20and%20studio%20lights%20on%20warm%20aged%20cream%20editorial%20backdrop%2C%20vintage%20archival%20documentary%20style%2C%20soft%20window%20light%2C%20muted%20terracotta%20and%20amber%20tones%2C%20minimal%20no%20text%2C%20high%20detail%20art%20direction&width=900&height=600&seq=hg-f-01&orientation=landscape",
  },
  {
    id: "f-02",
    category: "网红江湖",
    title: "从爆红到声量回落：一位素人网红的流量轨迹拆解",
    year: "2020 归档",
    tag: "流量解构",
    tone: "研究向",
    excerpt: "爆款视频为何能一夜出圈，流量又为何总在巅峰后回落？我们拆解传播节点、平台算法与大众情绪，还原走红背后的结构性逻辑。",
    image: "https://readdy.ai/api/search-image?query=floating%20glowing%20phone%20screens%20and%20streaming%20notifications%20hovering%20over%20warm%20cream%20archival%20paper%2C%20vintage%20editorial%20illustration%2C%20amber%20and%20terracotta%20palette%2C%20soft%20shadows%2C%20retro%20media%20vibe%2C%20minimal%20no%20text%2C%20high%20detail&width=900&height=600&seq=hg-f-02&orientation=landscape",
  },
  {
    id: "f-03",
    category: "综艺现场",
    title: "国民综艺的黄金十年：叙事、嘉宾与规则如何迭变",
    year: "2019 归档",
    tag: "年代观察",
    tone: "梳理向",
    excerpt: "一档节目如何从素人舞台长成全民话题？从赛制、剪辑到衍生生态，我们回看国民综艺在内容生产层面的十次关键转向。",
    image: "https://readdy.ai/api/search-image?query=vintage%20television%20studio%20with%20stage%20lights%20and%20clapperboard%20on%20warm%20cream%20backdrop%2C%20old%20broadcast%20equipment%20aesthetic%2C%20retro%20editorial%20photography%2C%20muted%20golden%20and%20red%20tones%2C%20nostalgic%2C%20no%20text%2C%20high%20detail&width=900&height=600&seq=hg-f-03&orientation=landscape",
  },
  {
    id: "f-04",
    category: "音乐现场",
    title: "版权纷争与翻红密码：经典老歌的二次生命",
    year: "2022 归档",
    tag: "翻红密码",
    tone: "科普向",
    excerpt: "一首多年前的歌，为何会在短视频时代被重新打捞？从版权归属到翻唱改编，我们聊聊经典旋律在平台浪潮里的第二次走红。",
    image: "https://readdy.ai/api/search-image?query=old%20vinyl%20record%20and%20cassette%20tapes%20arranged%20on%20warm%20cream%20paper%2C%20vintage%20music%20archival%20still%20life%2C%20amber%20lighting%2C%20retro%20editorial%20photography%2C%20muted%20terracotta%20tones%2C%20nostalgic%20atmosphere%2C%20no%20text%2C%20high%20detail&width=900&height=600&seq=hg-f-04&orientation=landscape",
  },
  {
    id: "f-05",
    category: "商业起伏",
    title: "从高光到低潮：一家造星公司的商业模式兴衰史",
    year: "2018 归档",
    tag: "资本复盘",
    tone: "商业向",
    excerpt: "当偶像工业站上风口，资本、平台与观众之间的张力如何展开？我们用几个关键节点，回看造星模式从喧嚣到冷静的完整曲线。",
    image: "https://readdy.ai/api/search-image?query=rising%20and%20falling%20financial%20chart%20curves%20sketched%20in%20ink%20on%20aged%20cream%20ledger%20paper%2C%20vintage%20business%20archival%20illustration%2C%20warm%20amber%20and%20deep%20red%20accents%2C%20minimal%20no%20text%2C%20high%20detail&width=900&height=600&seq=hg-f-05&orientation=landscape",
  },
  {
    id: "f-06",
    category: "行业观察",
    title: "从围观到共创：大众舆论参与方式的十年变迁",
    year: "2023 归档",
    tag: "生态洞察",
    tone: "深度向",
    excerpt: "十年前我们只是旁观者，如今每个人都能成为叙事的一部分。回看大众如何一步步从被动围观走向主动澄清、求证与再创作。",
    image: "https://readdy.ai/api/search-image?query=crowd%20of%20abstract%20paper%20figures%20watching%20a%20single%20lighted%20stage%20from%20a%20distance%2C%20warm%20cream%20archival%20style%20illustration%2C%20editorial%20minimalism%2C%20amber%20and%20terracotta%20palette%2C%20no%20text%2C%20high%20detail&width=900&height=600&seq=hg-f-06&orientation=landscape",
  },
];

export interface Collection {
  key: string;
  title: string;
  count: string;
  summary: string;
  image: string;
  picks: string[];
}

export const collections: Collection[] = [
  {
    key: "annual",
    title: "年度旧瓜总复习",
    count: "12 期",
    summary: "把一整年的热议事件按时间码好，适合在年底一次性补完全部进度。",
    image: "https://readdy.ai/api/search-image?query=stack%20of%20aged%20newspapers%20and%20yearly%20archive%20files%20bundled%20with%20red%20twine%20on%20warm%20cream%20desk%2C%20vintage%20archival%20editorial%20photography%2C%20amber%20lighting%2C%20muted%20terracotta%20tones%2C%20no%20text%2C%20high%20detail&width=1200&height=700&seq=hg-c-annual&orientation=landscape",
    picks: ["开年即登顶的三次刷屏", "盛夏的剧集大混战", "年终复盘：谁是年度赢家"],
  },
  {
    key: "showcase",
    title: "综艺名场面收藏夹",
    count: "20 期",
    summary: "高光时刻、冲突名场面与后来居上的逆袭，都被收进这一份综艺档案。",
    image: "https://readdy.ai/api/search-image?query=vintage%20stage%20spotlights%20and%20audience%20silhouettes%20captured%20on%20warm%20cream%20backdrop%2C%20retro%20variety%20show%20atmosphere%2C%20editorial%20photography%2C%20amber%20golden%20tone%2C%20nostalgic%2C%20no%20text%2C%20high%20detail&width=1200&height=700&seq=hg-c-show&orientation=landscape",
    picks: ["导师转身瞬间的节目学", "逆风翻盘的剧本之外", "台上台下：情绪如何被放大"],
  },
  {
    key: "reverse",
    title: "反转·澄清·落幕：舆论走向全记录",
    count: "15 期",
    summary: "被误读、被澄清、再被重新理解的样本，记录谣言如何在澄清后落幕。",
    image: "https://readdy.ai/api/search-image?query=compass%20and%20route%20lines%20on%20aged%20cream%20map%20paper%20representing%20shifting%20narratives%2C%20vintage%20editorial%20illustration%2C%20warm%20amber%20and%20deep%20red%20ink%2C%20minimal%20no%20text%2C%20high%20detail&width=1200&height=700&seq=hg-c-rev&orientation=landscape",
    picks: ["误读是如何被放大的", "一次澄清的传播路径", "热度退去后真正留下的"],
  },
  {
    key: "starter",
    title: "从零开始的考古入门",
    count: "6 期",
    summary: "给刚入坑的朋友准备的档案入门，三十分钟理清最近几年的大致脉络。",
    image: "https://readdy.ai/api/search-image?query=open%20notebook%20with%20handwritten%20timeline%20lines%20and%20paper%20clips%20on%20warm%20cream%20desk%2C%20vintage%20study%20archival%20photography%2C%20soft%20amber%20light%2C%20minimal%20no%20text%2C%20high%20detail&width=1200&height=700&seq=hg-c-start&orientation=landscape",
    picks: ["第一步：认识信息源头", "第二步：学会交叉求证", "第三步：建立自己的时间线"],
  },
];

export interface Era {
  label: string;
  years: string;
  title: string;
  summary: string;
  marker: string;
}

export const eras: Era[] = [
  { label: "起点", years: "2018 前", title: "初代围观时代", summary: "事件还在贴吧与微博早期发酵，一瓜往往要几天才完整展开，围观者以搬运与转发为主。", marker: "萌芽" },
  { label: "加速", years: "2018—2020", title: "刷屏与出圈", summary: "短视频与直播放大了传播速度，热门事件开始在同一天内完成从曝光到刷屏的全过程。", marker: "扩散" },
  { label: "迷雾", years: "2021—2022", title: "信息过载与求证", summary: "信息越多越难看清，反向求证成为标配，读者开始自发整理时间线对抗碎片化。", marker: "分化" },
  { label: "理性", years: "2023—2024", title: "考古与档案化", summary: "越来越多的人愿意回看旧料、建立脉络，站内自发的'翻旧账'沉淀为一种内容方式。", marker: "沉淀" },
  { label: "档案", years: "2025 至今", title: "去情绪化回顾", summary: "事件周期被拉长到以年为单位复盘，行业与读者共同转向更冷静的结构化回顾。", marker: "成熟" },
];

export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "什么是旧瓜考古？为什么大家喜欢翻旧瓜？",
    a: "旧瓜考古指的是重新翻看、梳理已经发生过但如今又被热议的往期娱乐与网络事件。很多人喜欢考古，是为了补上当年错过的前因后果，也为了看清一段舆论或事件是如何一步步发展到今天的完整脉络。",
  },
  {
    q: "档案里的时间线和合集是怎么整理的？",
    a: "我们按年份建立时间轴，把同类旧料归纳进经典合集，并通过档案检索与分类筛选，让每一段往期内容都能在几分钟内被定位到。",
  },
  {
    q: "我该如何快速找到想看的那段往期内容？",
    a: "可以使用档案库的搜索框输入关键词，或按影视、综艺、音乐等分类筛选，再结合年份时间线定位年代，即可快速锁定期望回顾的旧料。",
  },
  {
    q: "这些回顾内容是基于什么原则写的？",
    a: "档案以呈现事件时间线、公开信息与舆论演进的客观脉络为主，叙事克制，不做未经证实的主观断言，注重资料完整与可读性。",
  },
  {
    q: "档案会持续更新吗？新内容在哪里看？",
    a: "会的。新增的旧料会按时间归入对应年份与合集，读者回到首屏的档案检索区即可看到最新补充的往期整理。",
  },
];

export interface IndexRow {
  no: string;
  year: string;
  category: string;
  title: string;
  status: string;
  hot: number;
}

export const indexRows: IndexRow[] = [
  { no: "档-A-0132", year: "2026", category: "影视风云", title: "暑期档剧集口碑之争全复盘", status: "连载中", hot: 96 },
  { no: "档-A-0129", year: "2026", category: "网红江湖", title: "一条素人视频的出圈全链路", status: "已归档", hot: 91 },
  { no: "档-B-0087", year: "2025", category: "综艺现场", title: "音综现场：修音与真唱之争", status: "已归档", hot: 88 },
  { no: "档-B-0080", year: "2024", category: "音乐现场", title: "老歌翻红背后的版权流转", status: "已归档", hot: 84 },
  { no: "档-C-0065", year: "2023", category: "行业观察", title: "反转叙事：一次澄清的传播路径", status: "已归档", hot: 82 },
  { no: "档-C-0059", year: "2022", category: "商业起伏", title: "偶像工业：从风口到冷静期", status: "已归档", hot: 79 },
  { no: "档-D-0041", year: "2020", category: "网红江湖", title: "直播元年之后，谁在退潮", status: "已归档", hot: 74 },
  { no: "档-D-0036", year: "2019", category: "综艺现场", title: "国民综艺的赛制演进简史", status: "已归档", hot: 71 },
  { no: "档-E-0021", year: "2018", category: "行业观察", title: "初代围观：一个瓜要等几天", status: "已归档", hot: 66 },
];

export interface Testimonial {
  name: string;
  handle: string;
  text: string;
}

export const testimonials: Testimonial[] = [
  {
    name: "夜航读者",
    handle: "@haimian",
    text: "以前追瓜总是断断续续，补起来特别累。现在回档案区对着时间线看一遍，整个脉络立刻通了。",
  },
  {
    name: "一颗西柚",
    handle: "@xiao9",
    text: "最喜欢这里的叙事方式，克制、讲证据，不急着下结论。翻老料的过程像在读一份正经的行业档案。",
  },
  {
    name: "考古爱好者阿C",
    handle: "@acfile",
    text: "经典合集把散落的片段收好了，深夜考古终于不用在层层转发里翻半天了。",
  },
];